import { render, staticRenderFns } from "./MaskTool1.vue?vue&type=template&id=22072a38&scoped=true&"
import script from "./MaskTool1.vue?vue&type=script&lang=js&"
export * from "./MaskTool1.vue?vue&type=script&lang=js&"
import style0 from "./MaskTool1.vue?vue&type=style&index=0&id=22072a38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22072a38",
  null
  
)

export default component.exports